import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useI18n } from '../../../data/hooks/i18nHooks';
import { useScheduleSessionRoute } from '../../../data/hooks/routingHooks';
import { useSelectedSessions } from '../../../data/hooks/schedule/useSelectedSessions';
import { useVirtualRoom } from '../../../data/hooks/ui/useVirtualRoom';
import { useForceUpdate, useInterval } from '../../../misc/hooks';
import ContainedImage from '../../elements/ContainedImage';
import Time from '../EventWaitingRoom/common/Time';
import { useNextSession } from '../hooks';
import { SCHEDULE_SESSION_DISPLAY_TYPE_ROUND } from 'common-data-handling';

function timeToStart(start_utc) {
    return moment(start_utc).diff(moment(), 'seconds');
}

const NextProgram = (props) => {
    const { event, timeLimit = false, onChangeVisibility = () => {} } = props,
        i18n = useI18n(),
        now = moment(),
        [closed, setClosed] = useState([]),
        selectedSessions = useSelectedSessions(event.id),
        nextSession = useNextSession(event.id, {
            filter: (session) =>
                !closed.includes(session.id) &&
                (!timeLimit ||
                    moment(session.start_utc).diff(now, 'minutes') <
                        timeLimit) &&
                ((session.display_type == SCHEDULE_SESSION_DISPLAY_TYPE_ROUND &&
                    !selectedSessions.find((s) => s.round_id == session.id)) ||
                    (session.display_type !=
                        SCHEDULE_SESSION_DISPLAY_TYPE_ROUND &&
                        (session.is_selected || !session.is_selectable))),
        }),
        forceUpdate = useForceUpdate(),
        { primary_color } = event.settings,
        virtualRoom = useVirtualRoom(),
        href = useScheduleSessionRoute(event.id, nextSession?.id);

    // console.log(useUpcomingSessions(event.id));

    useInterval(forceUpdate, nextSession ? 200 : null);

    useEffect(() => onChangeVisibility(!!nextSession), [nextSession]);

    function handleClick() {
        app.history.push(href);
        app.store.dispatch(app.actions.ui.sidePanel.maximize(false));
    }

    function handleClose(e) {
        e.stopPropagation();
        setClosed([...closed, nextSession.id]);
    }

    if (nextSession && nextSession.id != virtualRoom?.programId) {
        return (
            <div className={'NextProgram'} onClick={handleClick}>
                <div
                    style={{
                        color: primary_color,
                        textTransform: 'uppercase',
                        whiteSpace: 'nowrap',
                    }}
                >
                    {i18n['label.next-session-short'] || 'NEXT SESSION IN'}
                    <Time
                        timestamp={nextSession.start_utc}
                        i18n={i18n}
                        primary_color={primary_color}
                    />
                    <ContainedImage
                        className="close"
                        src={'img/clear_icon.png'}
                        size={20}
                        style={{ marginLeft: 'auto', cursor: 'pointer' }}
                        onClick={handleClose}
                    />
                </div>
                <h2>{nextSession.name}</h2>
            </div>
        );
    }
    return null;
};
export default NextProgram;
